type Game9Map = {
  intro: string[]
  items: Array<{
    id: string
    label: string
    img: string
    comment: string
  }>
}

export const Game9Map: Game9Map = {
  intro: [
    'Při procházce lesem můžeš zahlédnout různé značky, stroje a zařízení, které lesníci využívají při hospodaření v lese nebo myslivci při péči o zvěř. Poznáš, k čemu slouží?',
    'Přiřaď ke každé fotografii správný název.',
  ],
  items: [
    {
      id: 'a',
      label: 'Sazenice ošetřená repelentem',
      img: require('../assets/game9/01_sazenice-osetrena-repelentem_Junek-min.jpg').default,
      comment:
        'Malé stromky v lese se natírají repelenty, aby je neokusovala lesní zvěř (jeleni, daňci, srnky) a stromky mohly dobře růst. Repelenty zvěři nevoní ani nechutnají.',
    },
    {
      id: 'b',
      label: 'Oplocenka',
      img: require('../assets/game9/02_oplocenka_PetraK-min.jpg').default,
      comment:
        'Aby zvěř neokusovala a jinak neničila malé lesní stromky, mohou lesníci naráz ochránit i větší prostor, třeba nově zalesněnou paseku. Proto se staví oplocenky, dřevěné nebo z drátěného pletiva.',
    },
    {
      id: 'c',
      label: 'Strom označený k těžbě',
      img: require('../assets/game9/03_strom-oznaceny-k-tezbe_upr-min.jpg').default,
      comment:
        'Sprejem vyznačil strom lesník. Dřevorubci podle teček poznají, které stromy mají z lesa odstranit. Může se jednat o stromy nemocné nebo stromy omezující ostatní v růstu, nebo o tzv. mýtní těžbu, při níž jsou kmeny vybírané přímo na míru pro další zpracování. ',
    },
    {
      id: 'd',
      label: 'Kácecí hlavice',
      img: require('../assets/game9/04_kaceci-hlavice_smidovaLCR-min.jpg').default,
      comment:
        'Kácecí hlavice je součástí harvestoru, moderního stroje pro těžbu dříví. Hlavice dokáže stromy pokácet, změřit jejich délku, zbavit je větví, rozřezat na kratší kusy a uložit na hromady. Nelze ji ale použít všude, problém jí dělají listnaté dřeviny, dlouhé a křivé stromy.',
    },
    {
      id: 'e',
      label: 'Kazatelna',
      img: require('../assets/game9/05_kazatelna-min.jpg').default,
      comment:
        'Kazatelna je krytý posed. Myslivec, který z kazatelny pozoruje a loví zvěř má dobrý výhled a zvěř ho necítí, protože sedí vysoko.',
    },
    {
      id: 'f',
      label: 'Krmelec',
      img: require('../assets/game9/06_krmelec-min.jpg').default,
      comment:
        'Myslivci v krmelcích přilepšují lesní zvěři, která by jinak v zimě strádala hlady, okusovala mladé stromky a škodila lesu. Zakládají tam obilí a seno, které v létě nasušili.',
    },
    {
      id: 'g',
      label: 'Žebřík',
      img: require('../assets/game9/07_zebrik-min.jpg').default,
      comment:
        'Žebřík je jednoduchý posed, z kterého mohou myslivci pozorovat a lovit zvěř. Myslivec z žebříku dobře slyší zvuky lesa, zároveň je ale vidět každý jeho pohyb, proto se musí chovat zvlášť obezřetně a tiše.',
    },
    {
      id: 'h',
      label: 'Slanisko',
      img: require('../assets/game9/08_slanisko-min.jpg').default,
      comment:
        'Slaniska najdeme většinou poblíž krmelců. Myslivci sem dávají sůl, kterou zvěř ráda líže, čímž si doplňuje minerály. Jako slanisko dobře poslouží kmen stromu nebo starý vykotlaný pařez.',
    },
    {
      id: 'i',
      label: 'Stromky v chráničích',
      img: require('../assets/game9/09_stromky-v-chranicich_rehounkovaLCR-min.jpg').default,
      comment:
        'Vedle vybudování oplocenky a natírání sazenic repelenty existuje ještě další ochrana stromků proti okusu zvěří. To když se na ně nasadí plastové chrániče nebo se kolem nich postaví plůtky.',
    },
    {
      id: 'j',
      label: 'Otrávená trojnožka',
      img: require('../assets/game9/10_otravena-trojnozka_smidovaLCR_upr-min.jpg').default,
      comment:
        'Trojnožka je otrávený lapač. Brouci kůrovci jsou vůní feromonu přilákáni, ale po prokousání kůrou se otráví. Otrávené lapače se nejvíce používají na místech, kam se lesník obtížně dostává a kde nemůže stav kůrovců kontrolovat často.',
    },
    {
      id: 'k',
      label: 'Ochrana proti loupání',
      img: require('../assets/game9/11_ochrana-proti-loupani-min.jpg').default,
      comment:
        'Jeleni rádi hryžou - loupají - kůru stromů. Nejen v zimě, kdy není dostatek jiné potravy, ale přes celý rok. Dokáží tak poškodit i starší stromy, proto se kmeny obalují např. pletivem.',
    },
    {
      id: 'l',
      label: 'Harvestor',
      img: require('../assets/game9/12_harvestor_junek-min.jpg').default,
      comment:
        'Harvestor je moderní stroj, určený k těžbě dříví, který dokáže stromy pokácet, změřit jejich délku, zbavit je větví, rozřezat na kratší kusy a uložit na hromady. Harvestor ale nelze použít všude a vyplatí se jen tam, kde je třeba pokácet větší množství stromů na jednom místě.',
    },
    {
      id: 'm',
      label: 'Hranice chráněného území',
      img: require('../assets/game9/13_hranice-chraneneho-uzemi-min.jpg').default,
      comment:
        'Červené pruhy označují v terénu hranici chráněného území (jako např. přírodní rezervaci nebo 1. zónu národního parku). Díváme-li se dovnitř chráněného území, uvidíme dva červené pruhy. Při pohledu z chráněného území ven však pruh pouze jeden.',
    },
    {
      id: 'n',
      label: 'Lapač',
      img: require('../assets/game9/14_lapac_PetraFiserova-min.jpg').default,
      comment:
        'Lapač láká brouky kůrovce. Kůrovci se vyvíjí pod kůrou stromů a při velkém počtu dokáží zničit rozsáhlé plochy lesů. Lesníci lapače pravidelně obchází a stav kůrovců kontrolují. Proto brzy zjistí, když hrozí jejich přemnožení a mohou začít les bránit.',
    },
    {
      id: 'o',
      label: 'Lanové dopravní zařízení',
      img: require('../assets/game9/15_lanove-dopravni-zarizeni_PetraK_upr-min.jpg').default,
      comment:
        'Lanová zařízení pro dopravu dříví jsou velmi podobné lanovkám, které například na horách přepravují lyžaře. Dokážou vytáhnout dříví z těžko přístupných porostů (např. příkrých strání), kam nevede žádná cesta a odkud to nesvede ani traktor, ani kůň.',
    },
    {
      id: 'p',
      label: 'Polom',
      img: require('../assets/game9/16_polom-min.jpg').default,
      comment:
        'Tento polom v lese způsobila silná vichřice, která polámala dospělé stromy jako zápalky. Lesníci teď musí nechat polomové dřevo z lesa rychle odvézt, aby se v něm nenamnožili brouci kůrovci. Je to ale nebezpečná práce, kmeny leží jeden přes druhý a nečekaně se vymršťují.',
    },
    {
      id: 'q',
      label: 'Označení lesa',
      img: require('../assets/game9/17_oznaceni-lesa_web-min.jpg').default,
      comment:
        'Lesníci si čísly značí různé úseky lesa, aby se v něm snáze orientovali. Každý kousek lesa totiž potřebuje jinou péči, rostou v něm jiné druhy dřevin, je jinak starý či se liší typem terénu. Je to vlastně jako určení adresy ve městě – obrázek ukazuje hranici oddělení č. 416.',
    },
  ],
}
